const getters = {
    rosterStatus: state => state.rosterStatus,
    rosterErrors: state => state.rosterErrors,
    events: state => state.events,
    roster: state => state.roster,
}

export default getters
